import script from "./agent-findcustomer.vue?vue&type=script&setup=true&lang=js"
export * from "./agent-findcustomer.vue?vue&type=script&setup=true&lang=js"

import "./agent-findcustomer.vue?vue&type=style&index=0&id=5bd33b0c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bd33b0c"]])

export default __exports__